var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-game-root"},[_c('iframe',{ref:"iframe",staticClass:"l-game-content",attrs:{"src":_vm.iframeSrc,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }